import { AaSigninReq } from 'app/bff/models/aa/aaSignin';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { MbUpdateinfoReq } from 'app/bff/models/mb/mbUpdateinfo';
import { ROUTES } from 'app/core/router/paths';
import { ProcessStepCodesEnum } from 'app/features/Member/Settings/Email/types';
import { FormValues as SetupFormValues } from 'app/features/Member/Settings/Email/Setup/types';
import { EmailState, EmailActions, MEMBER_SETTING_EMAIL__SET_ACCESSIBLE_STEP, MEMBER_SETTING_EMAIL__AUTH_PASS_PHRASE, MEMBER_SETTING_EMAIL__SAVE_SETUP_PAGE_DATA, MEMBER_SETTING_EMAIL__SEND_EMAIL_OTP, MEMBER_SETTING_EMAIL__SEND_EMAIL_OTP_DONE, MEMBER_SETTING_EMAIL__AUTH_EMAIL_OTP, MEMBER_SETTING_EMAIL__SETUP_EMAIL, MEMBER_SETTING_EMAIL__UPDATE_CACHE, MEMBER_SETTING_EMAIL__RESET_CACHE } from './types';

/**
 * @description 設置可訪問步驟 (Action)
 * @param step 當前步驟
 */
export const setAccessibleStepAction = (step: ProcessStepCodesEnum): EmailActions => ({
  type: MEMBER_SETTING_EMAIL__SET_ACCESSIBLE_STEP,
  payload: { step }
});

/**
 * @description 驗證會員密碼 (Action)
 * @param args 請求所需的參數
 */
export const authPassPhraseAction = (args: AaSigninReq): EmailActions => ({
  type: MEMBER_SETTING_EMAIL__AUTH_PASS_PHRASE,
  payload: { args }
});

/**
 * @description 緩存「輸入新電子信箱」(Step-2-1) 資料 (Action)
 * @param data 頁面資料
 */
export const saveSetupPageDataAction = (data: SetupFormValues): EmailActions => ({
  type: MEMBER_SETTING_EMAIL__SAVE_SETUP_PAGE_DATA,
  payload: { data }
});

/**
 * @description 發送信箱 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 * @param redirectRoute 轉導路由
 */
export const sendEmailOTPAction = (args: AaOtpSendcodeReq, redirectRoute?: ROUTES): EmailActions => ({
  type: MEMBER_SETTING_EMAIL__SEND_EMAIL_OTP,
  payload: { args, redirectRoute }
});

/**
 * @description 發送信箱 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendEmailOTPDoneAction = (response: AaOtpSendcodeResp): EmailActions => ({
  type: MEMBER_SETTING_EMAIL__SEND_EMAIL_OTP_DONE,
  payload: { response }
});

/**
 * @description 驗證信箱 OTP 驗證碼 (Action)
 * @param authEmailOTPArgs 驗證手機 OTP 驗證碼，請求所需的參數
 * @param setupEmailArgs 更新會員電子郵件 (更新會員資料)，請求所需的參數
 */
export const authEmailOTPAction = (authEmailOTPArgs: AaOtpVerifyReq, setupEmailArgs: MbUpdateinfoReq): EmailActions => ({
  type: MEMBER_SETTING_EMAIL__AUTH_EMAIL_OTP,
  payload: { authEmailOTPArgs, setupEmailArgs }
});

/**
 * @description 設置會員電子郵件 (Action)
 * @param args 請求所需的參數
 */
export const setupEmailAction = (args: MbUpdateinfoReq): EmailActions => ({
  type: MEMBER_SETTING_EMAIL__SETUP_EMAIL,
  payload: { args }
});

/**
 * @description 更新資料緩存 (Action)
 * @param cache 緩存資料
 */
export const updateCacheAction = (cache: EmailState): EmailActions => ({
  type: MEMBER_SETTING_EMAIL__UPDATE_CACHE,
  payload: { cache }
});

/**
 * @description 重置資料緩存 (Action)
 */
export const resetCacheAction = (): EmailActions => ({
  type: MEMBER_SETTING_EMAIL__RESET_CACHE
});
